// extracted by mini-css-extract-plugin
export default {"button":"HeaderCartButton_button__DqSVW","icon":"HeaderCartButton_icon__rt9Fk","badge":"HeaderCartButton_badge__8uXJu","bump":"HeaderCartButton_bump__J6kwY"};